import { disableScroll, enableScroll } from './scroll-lock'

window.overlayActiveElement = null
window.headerOverlayActiveElement = null

// TODO: NTH pri zobrazeni a skryti transition pekny (podla vue, tam tie transition el)
function baseShow(activeElement, isHeader, allowScroll) {
    const overlay = isHeader ? document.querySelector('.js-header-overlay') : document.querySelector('.js-overlay')

    if (isHeader) {
        window.headerOverlayActiveElement = activeElement
    } else {
        window.overlayActiveElement = activeElement
    }

    requestAnimationFrame(() => {
        overlay.classList.add('is-active')

        if (!allowScroll) {
            disableScroll(overlay)
        }
    })
}

function baseHide(activeElement, isHeader) {
    const overlay = isHeader ? document.querySelector('.js-header-overlay') : document.querySelector('.js-overlay')

    if (isHeader && activeElement !== window.headerOverlayActiveElement) {
        return
    } else if (!isHeader && activeElement !== window.overlayActiveElement) {
        return
    }

    overlay.classList.remove('is-active')

    if (document.body.classList.contains('is-overlayed')) {
        enableScroll(overlay)
    }

    if (isHeader) {
        window.headerOverlayActiveElement = null
    } else {
        window.overlayActiveElement = null
    }
}

function showOverlay(activeElement, allowScroll = false) {
    baseShow(activeElement, false, allowScroll)
}

function hideOverlay(activeElement) {
    baseHide(activeElement, false)
}

function showHeaderOverlay(activeElement, allowScroll = false) {
    baseShow(activeElement, true, allowScroll)
}

function hideHeaderOverlay(activeElement) {
    baseHide(activeElement, true)
}

export { showOverlay, hideOverlay, showHeaderOverlay, hideHeaderOverlay }
